export const CurrencyValues = ['HKD', 'USD'];

export const RemittancePurposeSelectFilters = (t: any) => {
  return [
    { label: t('unionPay::payment-instruction.text--self-use'), value: 'self-use' },
    { label: t('unionPay::payment-instruction.text--buy-goods'), value: 'buy-goods' },
    { label: t('unionPay::payment-instruction.text--spending'), value: 'spending' },
    { label: t('unionPay::payment-instruction.text--household'), value: 'household' },
    { label: t('unionPay::payment-instruction.text--payroll'), value: 'payroll' },
    { label: t('unionPay::payment-instruction.text--personal-savings'), value: 'personal-savings' },
    { label: t('unionPay::payment-instruction.text--family-expense'), value: 'family-living-expenses' },
    { label: t('unionPay::payment-instruction.text--company-expense'), value: 'company-expense' }
  ];
};

export const FundSourceSelectFilters = (t: any) => {
  return [
    { label: t('unionPay::payment-instruction.text--income'), value: 'income' },
    { label: t('unionPay::payment-instruction.text--household'), value: 'household' },
    { label: t('unionPay::payment-instruction.text--friends-loan'), value: 'friends-loan' },
    { label: t('unionPay::payment-instruction.text--company-fund'), value: 'company-fund' },
    { label: t('unionPay::payment-instruction.text--personal-investment'), value: 'personal-investment' },
    { label: t('unionPay::payment-instruction.text--personal-savings'), value: 'personal-savings' },
    { label: t('unionPay::payment-instruction.text--wages'), value: 'wages' }
  ];
};
